import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'in',
      component: () => import('../views/index/index.vue'),
      // children: [
      //   {
      //     path: '',
      //     name: 'defaultCloud',
      //     redirect: '/index'
      //   }
      // ]
    },
    {
      path: '/index',
      name: 'index',
      component: () => import('../views/index/index.vue'),
      children: [
        {
          path: '',
          name: 'defaultIndexCloud',
        },
      ]
    },
    {
      path: '/m',
      name: 'm',
      component: () => import('../views/mobile/index.vue'),
      children: [
        {
          path: '',
          name: 'defaultMIndex',
          redirect: '/m/clean'
        },
        {
          path: 'cleanList',
          name: 'mcleanList',
          component: () => import('../views/mobile/cleanList/index.vue')
        },
      ]
    },

    
    {
      path: '/admin',
      name: 'admin',
      component: () => import('../views/admin/index.vue'),
      children: [
        {
          path: '',
          name: 'admin',
          redirect: '/admin/shopList'
        },
        {
          path: 'cleanList',
          name: 'cleanList',
          component: () => import('../views/admin/cleanManage/index.vue')
        },
        {
          path: 'shopList',
          name: 'shopList',
          component: () => import('../views/admin/shopManage/index.vue')
        },
        {
          path: 'shopDetail',
          name: 'shopDetail',
          component: () => import('../views/admin/shopManage/detail.vue')
        },
        {
          path: 'roomList',
          name: 'roomList',
          component: () => import('../views/admin/roomManage/index.vue')
        },
        {
          path: 'packageList',
          name: 'packageList',
          component: () => import('../views/admin/packageManage/index.vue')
        },
        {
          path: 'couponList',
          name: 'couponList',
          component: () => import('../views/admin/couponManage/index.vue')
        },
        {
          path: 'prizeList',
          name: 'prizeList',
          component: () => import('../views/admin/prizeManage/index.vue')
        },
        {
          path: 'orderList',
          name: 'orderList',
          component: () => import('../views/admin/orderManage/index.vue')
        },
        {
          path: 'userList',
          name: 'userList',
          component: () => import('../views/admin/userManage/index.vue')
        },
        {
          path: 'rechargeDetail',
          name: 'rechargeDetail',
          component: () => import('../views/admin/userManage/rechargeDetail.vue')
        },
        {
          path: 'roleList',
          name: 'roleList',
          component: () => import('../views/admin/roleManage/index.vue')
        },
        {
          path: 'annouceList',
          name: 'annouceList',
          component: () => import('../views/admin/annouceManage/index.vue')
        },
        {
          path: 'rechargeList',
          name: 'rechargeList',
          component: () => import('../views/admin/rechargeManage/index.vue')
        },
        {
          path: 'userCouponList',
          name: 'userCouponList',
          component: () => import('../views/admin/userCouponManage/index.vue')
        },
        {
          path: 'otaList',
          name: 'otaList',
          component: () => import('../views/admin/otaManage/index.vue')
        },
        {
          path: 'channelInviteList',
          name: 'channelInviteList',
          component: () => import('../views/admin/channelInviteManage/index.vue')
        },
        {
          path: 'channelInviteStats',
          name: 'channelInviteStats',
          component: () => import('../views/admin/channelInviteManage/stats.vue')
        },
        {
          path: 'menuList',
          name: 'menuList',
          component: () => import('../views/admin/menuManage/index.vue')
        },
        {
          path: 'employeeList',
          name: 'employeeList',
          component: () => import('../views/admin/employeeManage/index.vue')
        },
        {
          path: 'errorPointList',
          name: 'errorPointList',
          component: () => import('../views/admin/errorManage/errorPointList.vue')
        },
        {
          path: 'errorPointDetail',
          name: 'errorPointDetail',
          component: () => import('../views/admin/errorManage/errorPointDetail.vue')
        },
        {
          path: 'errorDetail',
          name: 'errorDetail',
          component: () => import('../views/admin/errorManage/errorDetail.vue')
        },
        {
          path: 'aiOrderList',
          name: 'aiOrderList',
          component: () => import('../views/admin/errorManage/aiOrderList.vue')
        },
        {
          path: 'tenantList',
          name: 'tenantList',
          component: () => import('../views/admin/tenantManage/index.vue')
        },
        {
          path: 'tenantDetail',
          name: 'tenantDetail',
          component: () => import('../views/admin/tenantManage/detail.vue')
        },
        {
          path: 'merchantList',
          name: 'merchantList',
          component: () => import('../views/admin/merchantManage/index.vue')
        },
        {
          path: 'merchantDetail',
          name: 'merchantDetail',
          component: () => import('../views/admin/merchantManage/detail.vue')
        },
        {
          path: 'statsList',
          name: 'statsList',
          component: () => import('../views/admin/statsManage/index.vue')
        },
        {
          path: 'pointMallList',
          name: 'pointMallList',
          component: () => import('../views/admin/pointMallManage/index.vue')
        },
        {
          path: 'exchangeRecordList',
          name: 'exchangeRecordList',
          component: () => import('../views/admin/exchangeRecordManage/index.vue')
        }
      ]
    },
  ]
})

export default router
